var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      staticClass: "app-header navbar is-fixed-top gtm-header",
      class: _vm.headerClass,
      attrs: { role: "navigation", "aria-label": "main navigation" },
    },
    [
      _c(
        "div",
        { staticClass: "navbar-brand" },
        [
          _vm._t("brand"),
          _c(
            "div",
            {
              staticClass: "navbar-burger burger",
              class: { "is-active": _vm.showNav },
              attrs: { "data-target": "navMenu" },
              on: {
                click: function ($event) {
                  _vm.showNav = !_vm.showNav
                },
              },
            },
            [_c("span"), _c("span"), _c("span")]
          ),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "navbar-menu", class: { "is-active": _vm.showNav } },
        [
          _c("div", { staticClass: "navbar-start" }, [_vm._t("navigation")], 2),
          _c(
            "div",
            { staticClass: "navbar-end" },
            [
              _c("div", { staticClass: "navbar-item" }, [
                _vm.impersonating
                  ? _c(
                      "div",
                      { staticClass: "impersonating" },
                      [
                        _c("dc-icon", {
                          attrs: {
                            icon: "exclamation-circle",
                            library: "far",
                            size: "lg",
                          },
                        }),
                        _vm._v(
                          "You're temporarily logged in as this user. When you're done, log out "
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._t("logo"),
              _c(
                "div",
                {
                  staticClass: "navbar-item has-dropdown",
                  class: { "is-active": _vm.active },
                },
                [
                  _vm.currentUser !== null
                    ? _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "click-outside",
                              rawName: "v-click-outside",
                              value: _vm.onClickOutside,
                              expression: "onClickOutside",
                            },
                          ],
                          staticClass: "navbar-link user-avatar",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.toggle.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("avatar", {
                            staticClass: "header-avatar mr-2",
                            attrs: {
                              image: _vm.currentUser.image,
                              alt: _vm.fullName,
                              cropped: true,
                              size: "is-32x32",
                              "is-rounded": "",
                            },
                          }),
                          _vm._v(" " + _vm._s(_vm.fullName) + " "),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "navbar-dropdown" }, [
                    _c(
                      "span",
                      { on: { click: _vm.close } },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "navbar-item gtm-view-logged-in-user-profile",
                            attrs: { to: _vm.profilelink },
                          },
                          [_vm._v(" Profile ")]
                        ),
                      ],
                      1
                    ),
                    _vm.helpLink
                      ? _c("hr", { staticClass: "navbar-divider" })
                      : _vm._e(),
                    _vm.helpLink
                      ? _c(
                          "a",
                          {
                            staticClass: "navbar-item gtm-help-link",
                            attrs: { href: _vm.helpLink, target: "_blank" },
                          },
                          [_vm._v(" Help ")]
                        )
                      : _vm._e(),
                    _c("hr", {
                      staticClass: "navbar-divider is-hidden-tablet",
                    }),
                    _c(
                      "a",
                      {
                        staticClass:
                          "navbar-item gtm-send-us-message is-hidden-tablet",
                        on: { click: _vm.newMessage },
                      },
                      [_vm._v(" Send us a message ")]
                    ),
                    _c("hr", { staticClass: "navbar-divider" }),
                    _c(
                      "a",
                      {
                        staticClass: "navbar-item gtm-log-out",
                        on: { click: _vm.logout },
                      },
                      [_vm._v(" Logout ")]
                    ),
                  ]),
                ]
              ),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }